export interface ITicket {
  id: string;
  tenantId: string;
  title: string;
  contactId: string;
  status: string;
  priority: string;
  description: string;
  assignedId: string;
  assignedType: string;
  createdAt: string;
  contact: any;
  attachment: any;
  attachments: any;
  assignedUser: any;
  assignedTeam: any;
}

export interface ITicketCreate {
  title: string;
  contactId: string;
  assignedId: any | null;
  status: string;
  priority: string;
  description: string;
}

export interface IGetTicketListResponse {
  data?: {
    ticket?: {
      list?: ITicket[];
      total?: number;
    };
  };
}

export interface ITicketListResult {
  list: ITicket[];
  total: number;
}

// COMMENT
export interface IComment {
  id: string;
  userName: string;
  ProfileURL: string;
  content: string;
  createdAt: string;
  attachments?: any;
}

export interface IGetCommentListResponse {
  data?: {
    comment?: {
      list?: {
        id: string;
        user: { firstName: string | null; lastName: string | null; ProfileURL: string | null };
        ProfileURL: string;
        content: string;
        createdAt: string;
        attachment: any;
        attachments: any;
      }[];
      total?: number;
    };
  };
}

export interface ICommentListResult {
  list: IComment[];
  total: number;
}

export interface IAddCommentParams {
  ticketId: string;
  userId: string;
  content: string;
  fileUrl?: any;
  fileType?: any;
  filename?: any;
}

// OTHER

export interface IDefaultFilter {
  filters: [] | { fieldname: string; search?: string; sort?: number }[];
  globalSearch: string;
  page: number;
  limit: number;
}

export type QueryParams = {
  orderBy: string;
  page: number;
  rowsPerPage: number;
  globalSearch: string;
  fieldSearch: Record<string, string>;
  order: string;
  dateTimeFiltre?: any;
};

export const defaultFilter = {
  filters: [{ fieldname: 'createdAt', sort: 1 }],
  globalSearch: '',
  page: 1,
  limit: 10,
};
